import request from './../utils/request'

/**
 * 获取分类详情
 */
export const getCategoryIdList = (params = {}) => {
  const { category_id } = params
  return request({
    url: `/category-by-id/${category_id}`,
    method: 'get'
  })
}

/**
 * 获取分类详情
 */
export const getCategoryList = (params = {}) => {
  const { category_path } = params
  return request({
    url: `/category/${category_path}`,
    method: 'get'
  })
}

/**
 * 获取分类mpm
 */
export const getCategoryMpm = (params = {}) => {
  const { category_path } = params
  return request({
    url: `/category-mpm/${category_path}`,
    method: 'get'
  })
}

/**
 * 获取文章列表
 */
export const getArticleList = (params = {}) => {
  return request({
    url: '/article',
    method: 'get',
    params
  })
}

/**
 * 搜索文章
 */
export const searchArticleList = (params) => {
  return request({
    url: '/article-search',
    method: 'get',
    params
  })
}

/**
 * 预览文章详情
 */
export const getArticlePreview = (params = {}) => {
  const { article_id, ...other } = params
  return request({
    url: `/article/preview/${article_id}`,
    method: 'get',
    params: other
  })
}

/**
 * 获取文章详情
 */
export const getArticleDetail = (params = {}) => {
  const { article_id } = params
  return request({
    url: `/article/${article_id}`,
    method: 'get'
  })
}

/**
 * 获取文章详情 - 其它（不加cdn）
 */
export const getArticleExtra = (params = {}) => {
  const { article_id, ...other } = params
  return request({
    url: `/article-extra/${article_id}`,
    method: 'get',
    params: other
  })
}

/**
 * 获取文章详情 - 下一篇
 */
export const getArticleNext = (params = {}) => {
  const { article_id, query } = params
  return request({
    url: `/article-next/${article_id}`,
    method: 'get',
    params: query
  })
}

/**
 * 获取相关文章列表
 */
export const getArticleRelation = (params = {}) => {
  return request({
    url: '/article-relation',
    method: 'get',
    params
  })
}

/**
 * 获取推荐文章列表
 */
export const getArticleRecommend = (params = {}) => {
  return request({
    url: '/article-recommend',
    method: 'get',
    params
  })
}

/**
 * 文章点赞
 */
export const postArticleLike = (data = {}) => {
  return request({
    url: '/like',
    method: 'post',
    data
  })
}

/**
 * 投票走势图
 * params: { id: 文章id, event_id: 活动id, voting_id: 投票id }
 */
export const getVotingTrend = (params = {}) => {
  return request({
    url: '/article-polling/voting-trend',
    method: 'get',
    params
  })
}

/**
 * 投票
 */
export const postVote = (data = {}) => {
  return request({
    url: '/article-polling/user-vote',
    method: 'post',
    data
  })
}

/**
 * 投票结果
 */
export const getVoteResult = (data = {}) => {
  return request({
    url: `/article-polling/vote-result`,
    method: 'post',
    data
  })
}
